            <div class="team-dash">
              <div class="kpi-band">
                <div class="kpi-hero">
                  <bst-widget-host #cf [query]="q('team.capacity_forecast')"
                    title="dashboard.w.team_capacity" subtitle="dashboard.w.team_capacity_sub"
                    [drillable]="true" (drilldown)="openDrill($event)">
                    @if ($any(cf.last)?.data; as d) {
                      <div class="hero-head">
                        <span class="hero-num">{{ d.totals.freeFteWeeks }}</span>
                        <span class="hero-unit">{{ 'dashboard.team.fte_weeks_free' | translate }}</span>
                        <!-- T7: the standalone Committed tile was cut; its percentage now
                             lives in this header instead, next to the free-capacity headline. -->
                        @if (d.totals.committedPct !== null) {
                          <span class="hero-committed">{{ 'dashboard.team.committed_pct' | translate:{ pct: d.totals.committedPct } }}</span>
                        }
                        <!-- rendered inline (not via bst-kpi-card) so the chip is the only content:
                             an empty-value kpi-card would leave an empty .kv block above it -->
                        @if (d.totals.atRiskMembers > 0) {
                          <div class="kchip chip-warning hero-chip-holder">
                            <nb-icon icon="clock-outline" aria-hidden="true"></nb-icon>
                            <span>{{ 'dashboard.team.below_commitment_chip' | translate:{ n: d.totals.atRiskMembers } }}</span>
                          </div>
                        } @else {
                          <div class="kchip chip-good hero-chip-holder">
                            <nb-icon icon="checkmark-circle-2-outline" aria-hidden="true"></nb-icon>
                            <span>{{ 'dashboard.team.fully_committed' | translate }}</span>
                          </div>
                        }
                      </div>
                      <bst-capacity-forecast [data]="d"></bst-capacity-forecast>
                    }
                  </bst-widget-host>
                </div>

                <bst-widget-host #rr [query]="q('team.rolloff')" title="dashboard.w.rev_at_risk" subtitle="dashboard.w.rev_at_risk_sub"
                  [drillable]="true" (drilldown)="openDrill($event)">
                  @if ($any(rr.last)?.data; as d) {
                    @if (d.moneyVisible) {
                      <bst-kpi-card class="rev-risk" [value]="'€ ' + (d.revenueAtRisk90d | number:'1.0-0')"
                        [suffix]="'dashboard.team.per_week' | translate"></bst-kpi-card>
                    } @else {
                      <div class="money-locked">{{ 'dashboard.team.locked_money' | translate }}</div>
                    }
                  }
                </bst-widget-host>

                <bst-widget-host #ta [query]="q('team.to_approve')" title="dashboard.w.to_approve"
                  [drillable]="true" (drilldown)="openDrill($event)">
                  @if ($any(ta.last)?.data; as d) {
                    <bst-kpi-card [value]="d.count"
                      [suffix]="d.oldestWeekStart ? ('dashboard.team.oldest_week' | translate:{ w: d.oldestWeekStart }) : ''"></bst-kpi-card>
                    <!-- stopPropagation: the card itself opens the drilldown drawer, and this
                         button is the shortcut past it. -->
                    @if (d.count > 0) {
                      <button nbButton status="primary" size="small" class="ta-action"
                        (click)="goApprovals(); $event.stopPropagation()">{{ 'dashboard.team.open_approvals' | translate }}</button>
                    }
                  }
                </bst-widget-host>
              </div>

              <!-- summary query runs invisibly (bare); only its backlog scalar is cross-referenced below -->
              <bst-widget-host #ts [bare]="true" [query]="q('team.summary')"></bst-widget-host>

              <!-- The health chips answer "how is my team doing right now", so they sit
                   directly under the KPI band instead of below two full-width panels. The
                   roster table they used to share a host with stays at the bottom and reads
                   this same host's result (one query either way; the batch dedups). -->
              <bst-widget-host #tr [flush]="true" [query]="q('team.roster')">
                <ng-container *ngIf="$any(tr.last)?.data as d">
                  <bst-team-health-strip [rows]="d.rows"
                    [backlog]="$any(ts.last)?.data?.approvalBacklogThisWeek ?? 0"></bst-team-health-strip>
                </ng-container>
              </bst-widget-host>

              <!-- T7: current-week margin demoted out of the KPI band. It only ever means
                   anything on the current week (see below) and competes for attention with
                   the hero's roll-off/at-risk figures for no real payoff, so it now renders
                   as a smaller secondary strip instead of a peer KPI tile. -->
              <div class="margin-strip">
                <!-- T5 team margin: current-week only (server also rejects other weeks); the
                     scope id is sent but the backend aggregates the manager's whole span. -->
                @if (atCurrentWeek) {
                  <bst-widget-host #tm
                    [query]="q('team.margin')"
                    title="dashboard.w.team_margin" subtitle="dashboard.w.team_margin_sub">
                    @if ($any(tm.last)?.data; as d) {
                      @if (d.suppressed) {
                        <bst-kpi-card [value]="'dashboard.team.margin_suppressed' | translate"
                          [suffix]="'dashboard.w.covered' | translate:{ pct: d.coveragePct }"></bst-kpi-card>
                      } @else if (d.marginPct === null) {
                        <bst-kpi-card [value]="'dashboard.unit.na' | translate"
                          [suffix]="'dashboard.w.covered' | translate:{ pct: d.coveragePct }"></bst-kpi-card>
                      } @else {
                        <bst-kpi-card [value]="d.marginPct + '%'"
                          [suffix]="'dashboard.w.covered' | translate:{ pct: d.coveragePct }"></bst-kpi-card>
                      }
                    }
                  </bst-widget-host>
                } @else {
                  <!-- F8/T4: static replacement for the bst-widget-host above when the period
                       isn't the current week (the metric can't be queried for other weeks).
                       .margin-unavailable copies widget-host's .wcard/.whead values locally:
                       view encapsulation scopes those classes to widget-host's own template,
                       so they can't be reused here. -->
                  <div class="margin-unavailable">
                    <h3>{{ 'dashboard.w.team_margin' | translate }}</h3>
                    <p>{{ 'dashboard.team.margin_current_week_only' | translate }}</p>
                  </div>
                }
              </div>

              <!-- flush: rail + table share one team.rolloff host (batch dedup makes the #rr compact query free) -->
              <bst-widget-host #ro [flush]="true" [query]="q('team.rolloff')">
                <ng-container *ngIf="$any(ro.last)?.data as d">
                  <div class="panel">
                    <h3>{{ 'dashboard.w.team_rolloff' | translate }} <span class="sub">{{ 'dashboard.w.team_rolloff_sub' | translate }}</span></h3>
                    <bst-horizon-rail [data]="d" (bucketSelected)="openBucket($event, $any(ro.last))"></bst-horizon-rail>
                  </div>
                  <div class="panel">
                    <h3>{{ 'dashboard.team.rolloff_table' | translate }}</h3>
                    <bst-team-rolloff-table [data]="d" (memberSelected)="memberSelected.emit($event)"></bst-team-rolloff-table>
                  </div>
                </ng-container>
              </bst-widget-host>

              <!-- F10/F11/T5: roster and utilization-by-member merged into one member table
                   (bst-team-roster carries the inline utilization bar + hours + timesheet +
                   ends columns already). Reads the #tr host declared above the fold rather
                   than opening a second one, so the roster is still a single query. Its
                   loading and error states are carried by that host's health strip. -->
              <div class="panel" *ngIf="$any(tr.last)?.data as d">
                <h3>{{ 'dashboard.team.roster' | translate }}</h3>
                <bst-team-roster [data]="d" (memberSelected)="memberSelected.emit($event)"></bst-team-roster>
              </div>
            </div>
